import {Location} from "@angular/common";
import {Component, OnInit, ViewChild} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {HelperService} from "../services/helper.service";
import {RilrService} from "../services/rilr.service";
import {NgxSpinnerService} from "ngx-spinner";
import {TosterMessageService} from "../services/toster-message.service";
import {LossPreventionAccessService} from "../services/loss-prevention-access.service";

@Component({
  selector: 'app-report-email-forward',
  templateUrl: './report-email-forward.component.html',
  styleUrls: ['./report-email-forward.component.scss'],
  providers: [RilrService, NgxSpinnerService, HelperService, TosterMessageService, LossPreventionAccessService],
})
export class ReportEmailForwardComponent implements OnInit {

  public filterData: any = {};
  public employeeSettings = {};
  public employeeData = [];
  public employeeList: any = [];
  public employeeSelectedData = [];
  public reportSystemID: number;
  public documentSystemID: number;
  public htmlErrorMessage: string = "";
  public selectedCompanySystemID = this.helperService.getSelectedCompanyId();
  @ViewChild('errorMessageHtml') errorMessageHtml: any;

  constructor(public bsModalRef: BsModalRef,
              private modalService: BsModalService,
              private rilrService: RilrService,
              private helperService: HelperService,
              private spinner: NgxSpinnerService,
              private lossPreventionAccessService: LossPreventionAccessService,
              private location: Location,
              private tosterMessageService: TosterMessageService) {
  }

  ngOnInit() {

    this.employeeSettings = {
      text: 'Select Employees',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      classes: 'myclass custom-class',
      primaryKey: 'employeeSystemID',
      labelKey: 'empName',
      enableSearchFilter: true,
      badgeShowLimit: 1,
    };
  }

  sendEmail() {
    const that = this;
    that.spinner.show();
    if (that.employeeSelectedData.length == 0) {
      that.htmlErrorMessage = 'Please select a employee';
      that.showErrorHtml();
      return false;
    }
    if (that.employeeSelectedData.length > 10) {
      that.htmlErrorMessage = 'At a time only 10 employees can send the email';
      that.showErrorHtml();
      return false;
    }
    that.filterData.companySystemID = that.helperService.getSelectedCompanyId();
    that.filterData.employeeSelectedData = that.employeeSelectedData;
    that.filterData.reportSystemID = that.reportSystemID;
    that.filterData.documentSystemID = that.documentSystemID;
    that.filterData.host = window.location.origin;
    that.rilrService
      .reportEmailForward()
      .post(that.filterData)
      .subscribe((rsp) => {
        that.spinner.hide();
        that.tosterMessageService.showSuccess("Success", "Report has been forwarded successfully");
        that.closeModal();
      }, (error) => {
        that.spinner.hide();
      });
  }

  closeModal() {
    this.bsModalRef.hide();
    this.modalService.setDismissReason('report_email__forward');
  }

  showErrorHtml() {
    setTimeout(() => {
      this.errorMessageHtml.show();
    }, 0);
  }

  public getEmployees(value: any) {
    const that = this;
    this.lossPreventionAccessService
      .getTypeheadEmployeesMulti()
      .get({
        'search': value,
        companySystemID: that.selectedCompanySystemID,
      })
      .subscribe(resp => {
        var tempOption = resp.data.data;
        that.employeeList = [];
        tempOption.forEach(function(value) {
          that.employeeList.push(value);
        });
      }, (err) => {
        that.employeeList = [];
      });
  }

  onSearch(evt: any) {
    this.employeeList = [];
    this.getEmployees(evt.target.value);
  }

}



// WEBPACK FOOTER //
// /app/src/app/report-email-forward/report-email-forward.component.ts